(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3140],{

/***/ 75507:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/[shortname]",
      function () {
        return __webpack_require__(94548);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ CardInnerTitle; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);





var CardInnerTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("padding:1.5rem 1rem;border-bottom:2px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";display:flex;align-items:center;height:64px;", props.isSpaceBetween && "justify-content: space-between;"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h3", {
                "data-test-id": props["data-test-id"],
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0 4px 0 0;font-size:16px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";"),
                children: props.title
            }),
            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, {
                linkTo: props.helpLink || undefined,
                size: "large",
                children: props.helpText
            }),
            props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";margin:0 35px 0 16px;", props.subTitleCss),
                children: props.sub
            }),
            props.children
        ]
    });
};


/***/ }),

/***/ 44117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96747);



var CheckIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "check",
        className: props.className
    });
};


/***/ }),

/***/ 53156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ DescriptionList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33869);
/* harmony import */ var _CheckIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44117);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              display: flex;\n              word-break: break-all;\n              font-size: 14px;\n              line-height: 1.3;\n              color: ",
        ";\n              margin-bottom: 0.7rem;\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 1;\n                font-weight: ",
        ";\n                padding-left: ",
        ";\n                margin-right: ",
        ";\n              "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                flex: 2;\n                white-space: pre-wrap;\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var DescriptionList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dl", {
        className: props.className,
        children: Object.entries(props.list).filter(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), _ = _param[0], v = _param[1];
            return v.isHidden !== true;
        }).map(function(param, i) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("dt", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold, v.indent && "12px", v.indent && "-12px"),
                        children: [
                            k,
                            v.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_3__/* .Help */ .W, {
                                linkTo: v.helpLink,
                                children: v.help
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("dd", {
                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2()),
                        className: v.extraClassName,
                        children: v.bool ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_CheckIcon__WEBPACK_IMPORTED_MODULE_4__/* .CheckIcon */ .n, {}) : v.text
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 67910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ EnterpriseGuide; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48261);







var EnterpriseGuide = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0 auto;display:flex;flex-direction:column;align-items:center;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";padding:56px 64px;justify-content:center;max-width:1120px;"),
        className: "enterprise-guide " + props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("p", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin:0;margin-block-start:36px;font-size:16px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";text-align:center;"),
                children: [
                    "有料契約限定のコンテンツです。",
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
                    "無料トライアルに申し込むと、すべてのコンテンツをご覧になれます。"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:40px;width:100%;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
                    src: "/static/images/enterprise/paywall.png"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:56px;display:flex;flex-direction:column;align-items:center;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .trialRequestUrl */ .d1,
                        passHref: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                size: "normal",
                                children: "無料トライアルに申し込む"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("margin-top:16px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                            href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .loginPath */ .Qv,
                            decoration: "none",
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:16px;"),
                            children: "契約済みの方はログインしてください"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 98257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FormattedNumber; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41181);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15598);






var FormattedNumber = function(props) {
    if (props.children === null || props.children === undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("span", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("span", {
                className: props.className,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                        className: _lib_wovn__WEBPACK_IMPORTED_MODULE_4__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
                        children: (0,_lib_number__WEBPACK_IMPORTED_MODULE_1__/* .formatWithComma */ .m$)(props.children)
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin-left:4px;"),
                        children: props.unit
                    })
                ]
            }),
            props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:12px;line-height:1.5;"),
                children: props.sub
            })
        ]
    });
};


/***/ }),

/***/ 89277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LineClampText; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);




var LineClampText = function(param) {
    var lineNumber = param.lineNumber, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, _height = param.height, height = _height === void 0 ? 1.4 : _height, _size = param.size, size = _size === void 0 ? "14px" : _size, _stripLineBreaks = param.stripLineBreaks, stripLineBreaks = _stripLineBreaks === void 0 ? false : _stripLineBreaks, _justify = param.justify, justify = _justify === void 0 ? false : _justify, lineClampRef = param.lineClampRef, className = param.className, children = param.children, dataTestId = param.dataTestId;
    if (typeof lineNumber === "number") {
        lineNumber = {
            desktop: lineNumber,
            mobile: lineNumber
        };
    }
    var text = stripLineBreaks ? children === null || children === void 0 ? void 0 : children.replace(/(\r\n|\n|\r)/gm, "") : children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
        title: text !== null && text !== void 0 ? text : "",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("line-height:", height, ";font-size:", size, ";", justify ? "text-align: justify;" : "", " ", showAll || "\n          max-height: calc(".concat(size, " * ").concat(height, " * ").concat(lineNumber.desktop, ");\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          -webkit-line-clamp: ").concat(lineNumber.desktop, ";\n          ").concat(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, " {\n            max-height: calc(").concat(size, " * ").concat(height, " * ").concat(lineNumber.mobile, ");\n            -webkit-line-clamp: ").concat(lineNumber.mobile, ";\n          }\n        ")),
        className: className,
        ref: lineClampRef,
        "data-test-id": dataTestId,
        children: text
    });
};


/***/ }),

/***/ 84044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LoadableButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);






var LoadableButton = function(_param) {
    var _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _spinnerColor = _param.spinnerColor, spinnerColor = _spinnerColor === void 0 ? plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.border */ .O9.border : _spinnerColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "isLoading",
        "spinnerColor"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: isLoading && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:transparent !important;position:relative;pointer-events:none;&::after{animation:", spinAround, " 500ms infinite linear;border:2px solid ", spinnerColor, ";border-radius:50%;border-right-color:transparent;border-top-color:transparent;content:'';display:block;height:1em;position:absolute;width:1em;position:absolute;left:calc(50% - (1em / 2));top:calc(50% - (1em / 2));position:absolute !important;}")
    }, props));
};
var spinAround = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)("@keyframes spinAround\n  from{transform:rotate(0deg);}to{transform:rotate(359deg);}");


/***/ }),

/***/ 91633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);



var Loader = function(param) {
    var _color = param.color, color = _color === void 0 ? "#999" : _color;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("height:0;width:0;padding:10px;border:3px solid ", color, ";border-right-color:transparent;opacity:0.5;border-radius:22px;animation:rotate 1s infinite ease-in-out;@keyframes rotate{100%{-webkit-transform:rotate(360deg);}}")
    });
};


/***/ }),

/***/ 14792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "cq": function() { return /* binding */ TableHeading; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "ss": function() { return /* binding */ TableHead; },
/* harmony export */   "vQ": function() { return /* binding */ SubLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);








var Table = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("table", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        id: props.id,
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;white-space:nowrap;overflow-x:auto;}background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";width:100%;/* This style is necessary to use sticky header */\n        border-collapse:separate;border-spacing:0;thead{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray40 */ .O9.gray40, ";border-collapse:collapse;}th,td{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50, ";}th{font-size:13px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";white-space:nowrap;padding:1rem 0.8rem 1rem 0.8rem;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}}")
    }, props));
};
var TableHead = function(props) {
    var _offset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("thead", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("th{position:", props.sticky ? "sticky" : "static", ";top:", (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 0, ";}"),
        "data-test-id": props.dataTestId,
        children: props.children
    });
};
var TableRow = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("tr", {
        css: props.highlightOnHover && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("transition:0.3s;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white10 */ .O9.white10, ";}"),
        className: props.className,
        "data-appcues": props["data-appcues"],
        children: props.children
    });
};
var TableCell = function(_param) {
    var _omitted = _param.omitted, omitted = _omitted === void 0 ? false : _omitted, _nowrap = _param.nowrap, nowrap = _nowrap === void 0 ? false : _nowrap, _align = _param.align, align = _align === void 0 ? "left" : _align, _vertical = _param.vertical, vertical = _vertical === void 0 ? "top" : _vertical, _centerized = _param.centerized, centerized = _centerized === void 0 ? false : _centerized, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "omitted",
        "nowrap",
        "align",
        "vertical",
        "centerized"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("td", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";line-height:1.5;padding:0.8rem;text-align:", centerized ? "center" : align, ";vertical-align:", centerized ? "middle" : vertical, ";", props.width && "width: ".concat(props.width, ";"), " ", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}"),
        colSpan: props.colSpan || 1,
        rowSpan: props.rowSpan || 1,
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{white-space:nowrap;}", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{white-space:", nowrap ? "nowrap" : "pre-wrap", ";}", omitted && omittedStyle),
            children: props.empty ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(EmptySymbol, {}) : props.children
        })
    });
};
var EmptySymbol = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:center;margin-left:25px;"),
        children: "-"
    });
};
var omittedStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("max-height:calc(14px * 1.4 * 3);-webkit-line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;");
var TableHeading = function(_param) {
    var _align = _param.align, align = _align === void 0 ? "left" : _align, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "align"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("th", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:", align, ";", props.width && "width: ".concat(props.width, ";")),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;", props.justify && "justify-content: ".concat(props.justify, ";")),
            children: [
                props.children,
                props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(SubLabel, {
                    children: props.sub
                }),
                props.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.helpProps), {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin-left:3px;"),
                    children: props.help
                }))
            ]
        })
    });
};
var SubLabel = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";margin-left:3px;line-height:1.5;"),
        children: "（".concat(props.children, "）")
    });
};


/***/ }),

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TagButton; },
/* harmony export */   "U": function() { return /* binding */ TagButtonGroup; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);






var TagButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:inline-block;margin:0 4px 4px 0;"),
        "data-test-id": "tag",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .TAG_HREF */ .cS,
            as: "slug" in props.tag ? (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .newTagPath */ .w6)(props.tag) : props.tag.path,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                "data-test-id": "tag-link",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";border-radius:3px;padding:2px 6px;font-size:12px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray90 */ .O9.gray90, ";text-align:center;display:block;white-space:nowrap;transition:0.3s;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray70 */ .O9.gray70, ";}"),
                className: "tag-button ".concat(props.className ? props.className : ""),
                children: "#".concat(props.tag.name)
            })
        })
    });
};
var TagButtonGroup = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0 0 -4px;padding:0;"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: props.children
    });
};


/***/ }),

/***/ 90308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ForEnterprise; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18584);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73650);




var ForEnterprise = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* .useUser */ .a)();
    if ((0,_lib_user__WEBPACK_IMPORTED_MODULE_2__/* .isEnterpriseWithTrial */ .xQ)(user)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: props.children
        });
    } else {
        return null;
    }
};


/***/ }),

/***/ 75575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FundsTable; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14792);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20932);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41181);
/* harmony import */ var _EmptyCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23581);
/* harmony import */ var _Help__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33869);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14380);








var FundsTable = function(props) {
    if (props.list.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_EmptyCard__WEBPACK_IMPORTED_MODULE_4__/* .EmptyCard */ .S, {});
    }
    var fundUrl = function(fund) {
        var iShortname = props.investorShortName ? props.investorShortName : fund.investorShortnames[0];
        return "/investors/".concat(iShortname, "/funds/").concat(fund.shortname);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .Table */ .iA, {
        className: "fund-table",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("thead", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: "ファンド名"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: [
                                "ファンド額",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .SubLabel */ .vQ, {
                                    children: "百万円"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "出資総額"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: "設立年月日"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: "種別"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: [
                                "ファンド類型",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "地域密着型、汎用型、業種特化型、産学連携型、シードアクセラレーター等"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableHeading */ .cq, {
                            children: [
                                "重点ステージ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "シード・アーリー・エクスパンション・レータ\n・バランス型・バイアウト型・再生企業"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("tbody", {
                children: props.list.map(function(f) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                className: "fund-name",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_2__.A, {
                                    href: fundUrl(f),
                                    target: "_blank",
                                    decoration: "none",
                                    children: f.name
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                align: "right",
                                children: f.amount && (0,_lib_number__WEBPACK_IMPORTED_MODULE_3__/* .formatWithComma */ .m$)(f.amount)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_6__/* .FormattedDate */ .J, {
                                    children: f.established
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                children: f.classification
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                children: f.type
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_1__/* .TableCell */ .pj, {
                                children: f.stages.join(", ")
                            })
                        ]
                    }, f.id);
                })
            })
        ]
    });
};


/***/ }),

/***/ 33869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Help; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var Help = function(props) {
    var ref;
    if (props.linkTo) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                label: props.children ? (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
                id: "help",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: props.linkTo,
                    target: "_blank",
                    rel: "noopener",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";vertical-align:middle;&:active,&:visited{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                        text: props.children,
                        className: props.className,
                        size: props.size,
                        offset: props.offset
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: props.children ? (ref = props.children) === null || ref === void 0 ? void 0 : ref.toString() : "",
            id: "help",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                text: props.children,
                className: props.className,
                size: props.size,
                offset: props.offset
            })
        })
    });
};
var Icon = function(props) {
    var ref;
    var offset = "{'top': ".concat(((ref = props.offset) === null || ref === void 0 ? void 0 : ref.top) || 0, "}");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        "data-for": "help",
        "data-offset": offset,
        "data-tip": props.text,
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "question-circle-fill",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", props.size === "large" ? "20px" : "14px", ";")
        })
    });
};


/***/ }),

/***/ 6178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ViewMoreLink; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20932);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);






var ViewMoreLink = function(props) {
    // NOTE: props.onClickを渡すと、Hrefでの遷移はなくなる
    if (props.isHidden) {
        return null;
    }
    var _prefetch = props.prefetch, prefetch = _prefetch === void 0 ? true : _prefetch;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;width:100%;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white10 */ .O9.white10, ";padding-block:21px;font-size:14px;line-height:1;"),
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: props.href,
            as: props.as,
            prefetch: prefetch,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_atoms_A__WEBPACK_IMPORTED_MODULE_1__.A, {
                decoration: "none",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;"),
                onClick: props.onClick,
                "data-testid": "view-more-link",
                target: "_blank",
                children: [
                    "もっと見る",
                    props.count && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(),
                        children: [
                            "\xa0（",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                                "data-testid": "view-more-count",
                                children: props.count
                            }),
                            "）"
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 74497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ CompanyCardList; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
// EXTERNAL MODULE: ./lib/number.ts
var number = __webpack_require__(41181);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
;// CONCATENATED MODULE: ./components/atoms/NumberWIthUnit.tsx




var NumberWithUnit = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.black30 */.O9.black30, ";font-size:1.1rem;"),
                children: props.children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:12px;color:", dist/* colors.text */.O9.text, ";margin-left:8px;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";"),
                children: props.unit
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/investor/CompanyCard.tsx











var CompanyCard = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
        className: "company-item",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", dist.mq.extraLarge, "{flex-direction:row;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;", dist.mq.untilLarge, "{margin-bottom:1rem;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: props.company.path,
                                target: "_blnak",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                    size: "large",
                                    name: props.company.name,
                                    src: props.company.imageUrl,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:1rem;")
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", dist.mq.extraLarge, "{display:none;}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
                                        path: props.company.path,
                                        children: props.company.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResearchStatus, {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:5px;"),
                                        children: props.company.researchStatus
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;flex:1;padding-top:5px;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;", dist.mq.untilLarge, "{display:none;}"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
                                        path: props.company.path,
                                        children: props.company.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResearchStatus, {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:3.5rem;"),
                                        children: props.company.researchStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:14px;line-height:1.4;margin-top:7px;max-height:calc(14px * 1.4 * 2);-webkit-line-clamp:2;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;"),
                                children: props.company.description
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:6px;"),
                                children: props.company.tags.map(function(tag, i) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                        tag: tag
                                    }, i);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;display:flex;flex-direction:column;margin-top:1rem;", dist.mq.extraLarge, "{flex-direction:row;padding:0 1rem;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NumberSectionColumn, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelTag, {
                                                name: "スピーダ調達シリーズ"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                children: props.company.series || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelTag, {
                                                name: props.company.public ? "IPO時 時価総額(初値)" : "調達後評価額\n(".concat(props.company.valuationAnnotation, ")")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                children: props.company.valuation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberWithUnit, {
                                                            unit: "百万円",
                                                            children: (0,number/* formatWithComma */.m$)(props.company.public ? props.company.valuation : (0,number/* thousandToMillion */.Km)(props.company.valuation))
                                                        }),
                                                        !props.company.public && props.company.lastValuationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExtraValue, {
                                                            children: "".concat((0,date/* formatDate */.p6)(props.company.lastValuationDate, "yyyy/MM/dd"), "時点")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelTag, {
                                                name: "総調達額"
                                            }),
                                            props.company.totalFundRaise && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberWithUnit, {
                                                unit: "千円",
                                                children: (0,number/* formatWithComma */.m$)(props.company.totalFundRaise)
                                            }),
                                            !props.company.public && props.company.totalFundRaise && props.company.totalFundRaiseDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExtraValue, {
                                                children: "".concat((0,date/* formatDate */.p6)(props.company.totalFundRaiseDate, "yyyy/MM/dd"), "時点")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NumberSectionColumn, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelTag, {
                                                name: "設立"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                children: props.company.established ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                    children: props.company.established
                                                }) : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelTag, {
                                                name: props.company.public ? "IPO時 従業員数" : "従業員数"
                                            }),
                                            props.company.employees && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberWithUnit, {
                                                unit: "人",
                                                children: (0,number/* formatWithComma */.m$)(props.company.employees)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var Name = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: props.path,
        target: "_blank",
        className: props.className,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";color:", dist/* colors.black30 */.O9.black30, ";"),
            children: props.children
        })
    });
};
var ResearchStatus = function(props) {
    if (props.children === "調査継続") {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;color:", dist/* colors.textLight */.O9.textLight, ";"),
        className: props.className,
        children: props.children
    });
};
var LabelTag = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;padding:3px 10px;display:inline-block;color:", dist/* colors.black10 */.O9.black10, ";background-color:", dist/* colors.gray40 */.O9.gray40, ";border-color:", dist/* colors.gray40 */.O9.gray40, ";border-radius:3px;width:130px;text-align:center;font-size:11px;margin-right:10px;white-space:pre;", dist.mq.untilLarge, "{background-color:transparent;border-color:transparent;font-size:14px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";margin-right:1.5rem;text-align:left;width:160px;}"),
        children: props.name
    });
};
var NumberSectionColumn = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;height:100%;flex:1;white-space:nowrap;> div{margin-bottom:10px;margin-right:5px;}", dist.mq.untilLarge, "{justify-content:space-evenly;> div{margin-bottom:0.4rem;display:flex;}}"),
        children: props.children
    });
};
var ExtraValue = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("text-align:right;font-size:13px;display:block;color:", dist/* colors.gray90 */.O9.gray90, ";", dist.mq.untilMedium, "{margin-top:3px;text-align:left;}"),
        children: props.children
    });
};

// EXTERNAL MODULE: ./components/common/EmptyCard.tsx
var EmptyCard = __webpack_require__(23581);
;// CONCATENATED MODULE: ./components/pages/investor/CompanyCardList.tsx





var CompanyCardList = function(props) {
    if (props.list.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: props.list.map(function(c) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: props.className,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyCard, {
                        company: c
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {})
                ]
            }, c.id);
        })
    });
};


/***/ }),

/***/ 70703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CurrentInvestments; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73367);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14792);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20932);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48261);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41181);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23581);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14380);










var CurrentInvestments = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_2__/* .CardInnerTitle */ .W, {
                title: "ラウンド明細（投資先）一覧"
            }),
            props.list.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .Table */ .iA, {
                className: "startup-investment-table",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("thead", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "明細行"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "年月日"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "スタートアップ"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "ラウンド"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "内容"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "ファンド名"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    sub: "円",
                                    children: "株価"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "株数"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    sub: "千円",
                                    children: "投資額"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "備考"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("tbody", {
                        children: props.list.map(function(investment, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: (0,_lib_url__WEBPACK_IMPORTED_MODULE_5__/* .roundDetailUrl */ .ad)(investment.company.shortname, investment.shortname),
                                            decoration: "none",
                                            target: "_blank",
                                            children: investment.shortname
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_8__/* .FormattedDate */ .J, {
                                            children: investment.date
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: investment.company.path,
                                            decoration: "none",
                                            target: "_blank",
                                            children: investment.company.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.round
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.detail
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        className: "fund-name",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: "/investors/".concat(props.investorShortName, "/funds/").concat(investment.fund.shortname),
                                            decoration: "none",
                                            target: "_blank",
                                            children: investment.fund.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.price && (0,_lib_number__WEBPACK_IMPORTED_MODULE_6__/* .formatWithComma */ .m$)(investment.price, {
                                            decimalPlace: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.numOfStocks && (0,_lib_number__WEBPACK_IMPORTED_MODULE_6__/* .formatWithComma */ .m$)(investment.numOfStocks, {
                                            decimalPlace: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.amount && (0,_lib_number__WEBPACK_IMPORTED_MODULE_6__/* .formatWithComma */ .m$)(investment.amount)
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: investment.remark
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_7__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 31302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ DoubleColumnContent; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var DoubleColumnContent = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
        "data-test-id": props["data-test-id"],
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("padding:15px 25px !important;display:flex;flex-direction:column;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{flex-direction:row;> dl{width:50%;&:last-of-type{padding-left:1rem;}}}"),
        children: props.children
    });
};


/***/ }),

/***/ 51442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ExternalNewsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73367);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23581);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14380);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                    display: flex;\n                    flex-direction: row-reverse;\n                    grid-gap: 16px;\n                    ",
        " {\n                      flex-direction: row;\n                    }\n                  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      flex-basis: 112px;\n                      ",
        " {\n                        flex-basis: 144px;\n                      }\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        display: block;\n                        position: relative;\n                        border-radius: 2px;\n                        &::before {\n                          content: '';\n                          display: block;\n                          width: 100%;\n                          height: 100%;\n                          background-color: transparent;\n                          border-radius: 2px;\n                          position: absolute;\n                          transition: background-color 0.2s ease;\n                        }\n                        &:hover::before {\n                          background-color: rgba(0, 0, 0, 0.08);\n                        }\n                      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          display: block;\n                          object-fit: contain;\n                          width: 112px;\n                          aspect-ratio: 1.91 / 1;\n                          border-radius: 2px;\n                          ",
        " {\n                            width: 144px;\n                          }\n                        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      flex: 1;\n                    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        display: inline-block;\n                        color: ",
        ";\n                      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 14px;\n                          line-height: 1.5;\n                          font-weight: ",
        ";\n                          text-decoration: underline solid transparent;\n                          transition: text-decoration 0.2s ease 0s;\n                          &:hover {\n                            text-decoration: underline solid Currentcolor;\n                          }\n                        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        margin-top: 4px;\n                        color: ",
        ";\n                        font-size: 12px;\n                      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}







var defaultImg = "/static/images/no-image.png";
var ExternalNewsList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("margin-block-start:16px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-block-start:24px;}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__/* .CardInnerTitle */ .W, {
                title: "外部ニュース"
            }),
            props.list.length > 0 ? props.list.map(function(n, i) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card.Content */ .Zb.Content, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject(), plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large),
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large),
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                            href: n.url,
                                            target: "_blank",
                                            css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2()),
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("img", {
                                                src: n.imageUrl || defaultImg,
                                                alt: n.title,
                                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3(), plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject4()),
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                                href: n.url,
                                                target: "_blank",
                                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10),
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.bold */ .LZ.weight.bold),
                                                    children: n.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject7(), plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight),
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_5__/* .FormattedDate */ .J, {
                                                    children: n.publishedAt
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .iz, {})
                    ]
                }, i);
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 50179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ InvestorFinanceNewsList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57923);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73367);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23581);
/* harmony import */ var _lib_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25769);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                    display: flex;\n                  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      flex: 1;\n                      margin-left: 1rem;\n                    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 14px;\n                          color: ",
        ";\n                          line-height: 1.5;\n                          font-weight: ",
        ";\n                        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        display: flex;\n                        align-items: center;\n                        margin: 4px 0;\n                      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.25;\n                          color: ",
        ";\n                          background-color: ",
        ";\n                          border-radius: 15px;\n                          padding: 3px 8px;\n                          margin: 0 8px 0 0;\n                        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 12px;\n                          line-height: 1.25;\n                          color: ",
        ";\n                          padding: 4px 0;\n                        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                          font-size: 14px;\n                          line-height: 1.25;\n                          font-size: 14px;\n                          color: ",
        ";\n                        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var InvestorFinanceNewsList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_3__/* .CardInnerTitle */ .W, {
                title: "資金調達・提携ニュース"
            }),
            props.list.length > 0 ? props.list.map(function(n, i) {
                var org = n.company ? n.company : n.investor;
                if (!org) {
                    return;
                }
                var categoryColor = (0,_lib_colors__WEBPACK_IMPORTED_MODULE_5__/* .getCategoryTagColor */ .O6)(n.category);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject()),
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                        href: org.path,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .CompanyLogo */ .Dc, {
                                            name: org.name,
                                            src: org.imageUrl
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1()),
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                                href: n.urls[0],
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject2(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.text */ .O9.text, plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold),
                                                    children: n.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
                                                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3()),
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject4(), categoryColor.color, categoryColor.backgroundColor),
                                                        children: n.category
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject5(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight),
                                                        children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p6)(n.publishedAt, "yyyy/MM/dd")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("a", {
                                                href: org.path,
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6(), plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong),
                                                    children: org.name
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .iz, {})
                    ]
                }, i);
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 26404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ IpoSummaryList; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73367);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14792);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20932);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41181);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23581);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33869);









var IpoSummaryList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_2__/* .CardInnerTitle */ .W, {
                title: "投資サマリー（IPO企業）一覧"
            }),
            props.list.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .Table */ .iA, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("thead", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "スタートアップ"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: [
                                        "IPO直前株数",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_7__/* .Help */ .W, {
                                            children: "IPO直前の所有株数(潜在株を含む)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: [
                                        "シェア",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_7__/* .Help */ .W, {
                                            children: "IPO直前の所有株式(潜在株式を含む)の割合%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: [
                                        "投資額",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .SubLabel */ .vQ, {
                                            children: "千円"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_7__/* .Help */ .W, {
                                            children: "IPOまでに投資した金額(株式を譲受した場合は取得額を投資額に加算、\n譲渡した場合は売却額を投資額から減額)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: [
                                        "平均株価",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .SubLabel */ .vQ, {
                                            children: "円"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_7__/* .Help */ .W, {
                                            children: "投資金額合計(株式を譲受した場合は取得額を投資額に加算、\n譲渡した場合は売却額を投資額から減額)\xf7全株数"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableHeading */ .cq, {
                                    children: "備考"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("tbody", {
                        children: props.list.map(function(summary, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: summary.company.path,
                                            decoration: "none",
                                            target: "_blank",
                                            children: summary.company.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        align: "center",
                                        children: summary.preIpoNumOfStocks && (0,_lib_number__WEBPACK_IMPORTED_MODULE_5__/* .formatWithComma */ .m$)(summary.preIpoNumOfStocks, {
                                            decimalPlace: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        align: "center",
                                        children: [
                                            summary.share,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        align: "center",
                                        children: summary.totalInvestment && (0,_lib_number__WEBPACK_IMPORTED_MODULE_5__/* .formatWithComma */ .m$)(summary.totalInvestment)
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        align: "center",
                                        children: summary.stockAverage && (0,_lib_number__WEBPACK_IMPORTED_MODULE_5__/* .formatWithComma */ .m$)(summary.stockAverage, {
                                            decimalPlace: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_3__/* .TableCell */ .pj, {
                                        children: summary.remark
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_6__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 66863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LPInvestmentTable; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20932);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14792);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41181);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23581);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33869);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14380);








var LPInvestmentTable = function(props) {
    if (props.list.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_4__/* .EmptyCard */ .S, {});
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .Table */ .iA, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("thead", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("tr", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: "ファンド出資者明細"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: "ファンド"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: [
                                "開始日",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "取扱開始日、設立日、組成予定年月、（日は月末とする）"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: [
                                "ファンド額",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .SubLabel */ .vQ, {
                                    children: "百万円"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "出資総額"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            sub: "百万円",
                            children: "出資金額"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: "ファンド種別"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: [
                                "ファンド類型",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "地域密着型、汎用型、業種特化型、産学連携型、シードアクセラレーター等"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: [
                                "重点ステージ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "シード・アーリー・エクスパンション・レータ\n・バランス型・バイアウト型・再生企業"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableHeading */ .cq, {
                            children: [
                                "重点業種",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_5__/* .Help */ .W, {
                                    children: "ＩＴ関連・バイオ医療ヘルスケア(エネルギーを除く)\n・エネルギー関連・製品サービス"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("tbody", {
                children: props.list.map(function(detail, i) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("tr", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_1__.A, {
                                    decoration: "none",
                                    href: detail.path,
                                    children: detail.shortname
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_1__.A, {
                                    href: "/investors/".concat(props.shortname, "/funds/").concat(detail.fund.shortname),
                                    decoration: "none",
                                    children: detail.fund.name
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                nowrap: true,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_6__/* .FormattedDate */ .J, {
                                    children: detail.established
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                align: "right",
                                children: detail.amount && (0,_lib_number__WEBPACK_IMPORTED_MODULE_3__/* .formatWithComma */ .m$)(detail.amount)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: detail.investment && (0,_lib_number__WEBPACK_IMPORTED_MODULE_3__/* .formatWithComma */ .m$)(detail.investment, {
                                    decimalPlace: 1
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: detail.classification
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: detail.type
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: detail.stages.join(", ")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                                children: detail.industries.join(", ")
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};


/***/ }),

/***/ 58758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ LeadingVCCompanyList; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/CardInnerTitle.tsx
var CardInnerTitle = __webpack_require__(73367);
// EXTERNAL MODULE: ./components/atoms/Table.tsx
var Table = __webpack_require__(14792);
// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./components/common/EmptyCard.tsx
var EmptyCard = __webpack_require__(23581);
;// CONCATENATED MODULE: ./lib/dict.ts
var INDUSTRY = {
    communications: "通信・ネットワーキング",
    computer_hardware: "コンピューター - ハードウェア",
    computer_services: "コンピューター - ITサービス",
    computer_software: "コンピューター - ソフトウェア",
    semiconductors_electronics: "半導体/その他電子部品・製品",
    biotechnology: "バイオテクノロジー",
    biotechnology_ict: "バイオテクノロジー ICT",
    healthcare_related: "医療・ヘルスケア",
    healthcare_related_ict: "医療・ヘルスケア ICT",
    industrial_energy: "産業・エネルギー",
    industrial_energy_ict: "産業・エネルギー ICT",
    cleantechnology: "環境関連",
    cleantechnology_ict: "環境関連 ICT",
    retailing_media: "消費者向けサービス・販売",
    financial: "金融・保険・不動産",
    financial_ict: "金融・保険・不動産 ICT",
    business: "ビジネスサービス"
};

// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/investor/LeadingVCCompanyList.tsx









var LeadingVCCompanyList = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "IPO時のリード（トップ）VC一覧"
            }),
            props.list.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "スタートアップ"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "IPO年月日"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "証券コード"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "IPO市場"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "東証33業種"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "業種"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                    children: "シェア"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                        children: props.list.map(function(c, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                            href: c.path,
                                            decoration: "none",
                                            target: "_blank",
                                            children: c.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                            children: c.ipoDate
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: c.stockCode
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: c.market
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: c.industry
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                        children: INDUSTRY[c.jvrIndustry]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableCell */.pj, {
                                        children: [
                                            c.leadVcShare,
                                            " %"
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};


/***/ }),

/***/ 80888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ PastInvestments; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20932);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73367);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14792);
/* harmony import */ var _lib_number__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41181);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23581);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14380);











var unlinkableInvestorTypes = [
    "*創業者*",
    "*不明*",
    "*個人*",
    "*従業員*"
];
var unlinkableFundTypes = [
    "*創業者*",
    "*不明*",
    "*個人*"
];
var PastInvestments = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_5__/* .CardInnerTitle */ .W, {
                title: "ラウンド明細（移動前所有）一覧"
            }),
            props.list.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .Table */ .iA, {
                className: "startup-previous-investment-table",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("thead", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "明細行"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "年月日"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "スタートアップ"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "投資家名"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "ファンド名"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    sub: "円",
                                    children: "株価"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "株数"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    sub: "千円",
                                    children: "投資額"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableHeading */ .cq, {
                                    children: "備考"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("tbody", {
                        children: props.list.map(function(investment, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .roundDetailUrl */ .ad)(investment.company.shortname, investment.shortname),
                                            decoration: "none",
                                            target: "_blank",
                                            children: investment.shortname
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_9__/* .FormattedDate */ .J, {
                                            children: investment.date
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: investment.company.path,
                                            decoration: "none",
                                            target: "_blank",
                                            children: investment.company.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: unlinkableInvestorTypes.includes(investment.investor.name) ? investment.investor.name : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/investors?shortname=".concat(investment.investor.shortname),
                                            as: "/investors/".concat(investment.investor.shortname),
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                                decoration: "none",
                                                children: investment.investor.name
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        className: "fund-name",
                                        children: unlinkableFundTypes.includes(investment.fund.name) ? investment.fund.name : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_4__.A, {
                                            href: "/investors/".concat(investment.investor.shortname, "/funds/").concat(investment.fund.shortname),
                                            decoration: "none",
                                            children: investment.fund.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: investment.price && (0,_lib_number__WEBPACK_IMPORTED_MODULE_7__/* .formatWithComma */ .m$)(investment.price, {
                                            decimalPlace: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: investment.numOfStocks && (0,_lib_number__WEBPACK_IMPORTED_MODULE_7__/* .formatWithComma */ .m$)(investment.numOfStocks, {
                                            decimalPlace: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: investment.amount && (0,_lib_number__WEBPACK_IMPORTED_MODULE_7__/* .formatWithComma */ .m$)(investment.amount)
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: investment.remark
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_8__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 88212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PeopleTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _atoms_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20932);
/* harmony import */ var _atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73367);
/* harmony import */ var _atoms_SNSLinks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33879);
/* harmony import */ var _atoms_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14792);
/* harmony import */ var _common_EmptyCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23581);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      display: flex;\n                      align-items: center;\n                    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        white-space: nowrap;\n                      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                        margin-left: 0.5rem;\n                      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                      margin-top: 5px;\n                    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var PeopleTable = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_CardInnerTitle__WEBPACK_IMPORTED_MODULE_4__/* .CardInnerTitle */ .W, {
                title: props.title
            }),
            props.list.length > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .Table */ .iA, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("thead", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("th", {
                                    children: "名前"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("th", {
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("width:70%;"),
                                    children: "役職 / 役割"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("tbody", {
                        children: props.list.map(function(p) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
                                            css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject()),
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_A__WEBPACK_IMPORTED_MODULE_3__.A, {
                                                    href: p.path,
                                                    decoration: "none",
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject1()),
                                                    children: p.name
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_SNSLinks__WEBPACK_IMPORTED_MODULE_5__/* .SNSLinks */ .s, {
                                                    twitter: p.twitter,
                                                    facebook: p.facebook,
                                                    color: plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray80 */ .O9.gray80,
                                                    iconSize: 16,
                                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject2())
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_atoms_Table__WEBPACK_IMPORTED_MODULE_6__/* .TableCell */ .pj, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                                            css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject3()),
                                            children: p.title
                                        })
                                    })
                                ]
                            }, p.id);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_common_EmptyCard__WEBPACK_IMPORTED_MODULE_7__/* .EmptyCard */ .S, {})
        ]
    });
};


/***/ }),

/***/ 30291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EnterpriseGuideTemplate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _common_Head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12912);
/* harmony import */ var _common_Template__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33431);
/* harmony import */ var _atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67910);





var EnterpriseGuideTemplate = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Head__WEBPACK_IMPORTED_MODULE_1__/* .DefaultHead */ .UJ, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_common_Template__WEBPACK_IMPORTED_MODULE_2__/* .Template */ .Y, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_atoms_EnterpriseGuide__WEBPACK_IMPORTED_MODULE_3__/* .EnterpriseGuide */ .w, {})
            })
        ]
    });
};


/***/ }),

/***/ 25769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ getCategoryTagColor; }
/* harmony export */ });
/* unused harmony exports convertHexColorToRGB, categoryTagColor */
var convertHexColorToRGB = function(hex) {
    if (hex.slice(0, 1) == "#") hex = hex.slice(1);
    if (hex.length == 3) {
        hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3);
    }
    return [
        hex.slice(0, 2),
        hex.slice(2, 4),
        hex.slice(4, 6)
    ].map(function(str) {
        return parseInt(str, 16);
    });
};
var categoryTagColor = {
    yellow10: "#FFFAEB",
    yellow60: "#D19D00",
    blue10: "#F2F6FA",
    blue60: "#0863BF",
    cyan10: "#F0F6F8",
    cyan60: "#1B8298",
    navy10: "#F2F4FA",
    navy60: "#1F3A8C",
    green10: "#F2FAF3",
    green60: "#2F943C",
    forestGreen10: "#F7FCEB",
    forestGreen60: "#6F9905",
    red10: "#FFF2F2",
    red60: "#db351f",
    brown10: "#F7F3F0",
    brown60: "#704831",
    gray20: "#FAFAFA",
    gray90: "#666"
};
var getCategoryTagColor = function(category) {
    switch(category){
        case "資金調達":
            return {
                color: categoryTagColor.yellow60,
                backgroundColor: categoryTagColor.yellow10
            };
        case "資本提携":
            return {
                color: categoryTagColor.forestGreen60,
                backgroundColor: categoryTagColor.forestGreen10
            };
        case "資金参加":
            return {
                color: categoryTagColor.brown60,
                backgroundColor: categoryTagColor.brown10
            };
        case "事業提携":
            return {
                color: categoryTagColor.blue60,
                backgroundColor: categoryTagColor.blue10
            };
        case "子会社化":
            return {
                color: categoryTagColor.red60,
                backgroundColor: categoryTagColor.red10
            };
        case "株式譲渡":
            return {
                color: categoryTagColor.navy60,
                backgroundColor: categoryTagColor.navy10
            };
        case "事業譲渡":
            return {
                color: categoryTagColor.cyan60,
                backgroundColor: categoryTagColor.cyan10
            };
        case "ファンド組成":
            return {
                color: categoryTagColor.green60,
                backgroundColor: categoryTagColor.green10
            };
        default:
            return {
                color: categoryTagColor.gray90,
                backgroundColor: categoryTagColor.gray20
            };
    }
};


/***/ }),

/***/ 41181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ toUnitNumber; },
/* harmony export */   "Km": function() { return /* binding */ thousandToMillion; },
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "ii": function() { return /* binding */ millionToThousand; },
/* harmony export */   "m$": function() { return /* binding */ formatWithComma; }
/* harmony export */ });
/* unused harmony export inThousand */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39693);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_0__);


var formatWithComma = function(n, options) {
    if (n === null || n === undefined) {
        return "";
    }
    var ref = options || {}, _decimalPlace = ref.decimalPlace, decimalPlace = _decimalPlace === void 0 ? 0 : _decimalPlace;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(n.toFixed(decimalPlace).split("."), 2), base = ref1[0], decimalDigits = ref1[1];
    var formatted = base.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return lodash_compact__WEBPACK_IMPORTED_MODULE_0___default()([
        formatted,
        decimalDigits
    ]).join(".");
};
var inThousand = function(n) {
    var numberInThousand = Math.round(n / 1000);
    return formatWithComma(numberInThousand);
};
var millionToThousand = function(i) {
    return i ? i * 1000 : null;
};
var thousandToMillion = function(n) {
    return n ? Number(n * 0.001) : null;
};
var formatAmount = function(n) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        estimated: false
    };
    if (n === null || n === 0) {
        return null;
    }
    if (options.estimated) {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円（推定）"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円（推定）"
        };
    } else {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円"
        };
    }
};
var toUnitNumber = function(num) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (num >= 1000000000000) return {
        value: divideAndRound(num, 1000000000000, precision),
        unit: "T"
    };
    if (num >= 1000000000) return {
        value: divideAndRound(num, 1000000000, precision),
        unit: "B"
    };
    if (num >= 1000000) return {
        value: divideAndRound(num, 1000000, precision),
        unit: "M"
    };
    if (num >= 1000) return {
        value: divideAndRound(num, 1000, precision),
        unit: "K"
    };
    return {
        value: num,
        unit: null
    };
};
var divideAndRound = function(value, divisionNum, precision) {
    var n = Math.pow(10, precision);
    return Math.floor(value * n / divisionNum) / n;
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 94548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "COMPANIES_PER_PAGE": function() { return /* binding */ COMPANIES_PER_PAGE; },
  "INVESTOR_TOP_LIST_COUNT": function() { return /* binding */ INVESTOR_TOP_LIST_COUNT; },
  "default": function() { return /* binding */ _shortname_; },
  "timestamp": function() { return /* binding */ timestamp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./components/atoms/CardTitle.tsx
var CardTitle = __webpack_require__(4336);
// EXTERNAL MODULE: ./components/atoms/Loader.tsx
var Loader = __webpack_require__(91633);
// EXTERNAL MODULE: ./components/common/ForEnterprise.tsx
var ForEnterprise = __webpack_require__(90308);
// EXTERNAL MODULE: ./components/pages/investor/InvestorTemplate.tsx + 1 modules
var InvestorTemplate = __webpack_require__(79181);
// EXTERNAL MODULE: ./components/pages/investor/CompanyCardList.tsx + 2 modules
var CompanyCardList = __webpack_require__(74497);
// EXTERNAL MODULE: ./components/atoms/DescriptionList.tsx
var DescriptionList = __webpack_require__(53156);
// EXTERNAL MODULE: ./components/pages/investor/DoubleColumnContent.tsx
var DoubleColumnContent = __webpack_require__(31302);
// EXTERNAL MODULE: ./components/atoms/CheckIcon.tsx
var CheckIcon = __webpack_require__(44117);
;// CONCATENATED MODULE: ./components/pages/investor/InvestmentInfo.tsx







var InvestmentInfo = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                children: "投資情報"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                株主構成: {
                                    text: props.summary.shareholders
                                },
                                キャピタリスト数: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: props.summary.numOfCapitalists && "".concat(props.summary.numOfCapitalists, "人")
                                    })
                                },
                                JVCA会員: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: props.summary.jvcaMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckIcon/* CheckIcon */.n, {})
                                    })
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                国内拠点: {
                                    text: props.summary.domesticBase
                                },
                                海外拠点: {
                                    text: props.summary.overseasBase
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/atoms/A.tsx
var A = __webpack_require__(20932);
// EXTERNAL MODULE: ./lib/date.ts + 4 modules
var date = __webpack_require__(57923);
// EXTERNAL MODULE: ./components/atoms/SNSLinks.tsx + 1 modules
var SNSLinks = __webpack_require__(33879);
// EXTERNAL MODULE: ./contexts/AuthContext.ts
var AuthContext = __webpack_require__(18584);
// EXTERNAL MODULE: ./lib/user.ts
var lib_user = __webpack_require__(73650);
;// CONCATENATED MODULE: ./components/pages/investor/InvestorBasicInfo.tsx












var InvestorBasicInfo = function(props) {
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                children: "企業概要"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card */.Zb, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DoubleColumnContent/* DoubleColumnContent */.D, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                企業名: {
                                    text: props.summary.name
                                },
                                英語名: {
                                    text: props.summary.englishName
                                },
                                代表者名: {
                                    text: props.summary.representative
                                },
                                住所: {
                                    text: props.summary.address
                                },
                                電話番号: {
                                    text: props.summary.telephone,
                                    isHidden: (0,lib_user/* isGuest */.nJ)(user),
                                    extraClassName: "phone"
                                },
                                設立: {
                                    text: props.summary.established && (0,date/* formatDate */.p6)(props.summary.established, "yyyy/MM")
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Divider */.iz, {
                            dashed: true,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;margin:0.5rem 0;", dist.mq.large, "{display:none;}")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionList/* DescriptionList */.o, {
                            list: {
                                種別: {
                                    text: props.summary.category,
                                    help: "投資家の種別 (VC、海外VC、事業法人、金融機関など)"
                                },
                                属性: {
                                    text: props.summary.subCategory
                                },
                                旧または別名: {
                                    text: props.summary.formerName
                                },
                                URL: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                        href: props.summary.website,
                                        target: "_blank",
                                        children: props.summary.website
                                    })
                                },
                                SNS: {
                                    text: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SNSLinks/* SNSLinks */.s, {
                                                facebook: props.summary.facebook,
                                                twitter: props.summary.twitter,
                                                color: dist/* colors.black10 */.O9.black10,
                                                iconSize: 20,
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.untilMedium, "{display:none;}")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SNSLinks/* SNSLinks */.s, {
                                                facebook: props.summary.facebook,
                                                twitter: props.summary.twitter,
                                                color: dist/* colors.black10 */.O9.black10,
                                                iconSize: 20,
                                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{display:none;}")
                                            })
                                        ]
                                    })
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/FundsTable.tsx
var FundsTable = __webpack_require__(75575);
;// CONCATENATED MODULE: ./components/pages/investor/InvestorFunds.tsx




var InvestorFunds = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                helpText: props.helpText,
                helpProps: props.helpProps,
                children: "ファンド"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundsTable/* FundsTable */.B, {
                list: props.list,
                investorShortName: props.investorShortname
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/investor/ExternalNewsList.tsx
var ExternalNewsList = __webpack_require__(51442);
// EXTERNAL MODULE: ./components/pages/investor/InvestorFinanceNewsList.tsx
var InvestorFinanceNewsList = __webpack_require__(50179);
// EXTERNAL MODULE: ./components/common/ViewMoreLink.tsx
var ViewMoreLink = __webpack_require__(6178);
// EXTERNAL MODULE: ./components/atoms/CardInnerTitle.tsx
var CardInnerTitle = __webpack_require__(73367);
// EXTERNAL MODULE: ./components/common/EmptyCard.tsx
var EmptyCard = __webpack_require__(23581);
// EXTERNAL MODULE: ./components/common/npStartup/NewsPicksSearchResult.tsx
var NewsPicksSearchResult = __webpack_require__(45270);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./lib/api/np/feed.ts + 1 modules
var feed = __webpack_require__(13173);
;// CONCATENATED MODULE: ./components/pages/investor/NewsPicksNewsList.tsx












var NewsPicksNewsList = function(props) {
    var className = props.className ? [
        props.className,
        "np-feeds"
    ].join(" ") : "np-feeds";
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), npFeeds = ref[0], setNpFeeds = ref[1];
    (0,react.useEffect)(function() {
        setNpFeeds(null);
        (0,feed/* fetchNPFeedsByInvestorShortname */._J)(props.investorShortname).then(function(r) {
            setNpFeeds(r);
        }).catch(function(e) {
            return (0,log/* printError */.O)(e);
        });
    }, [
        props.investorShortname
    ]);
    if (!npFeeds) return null;
    var newsPicksFeeds = npFeeds.slice(0, 10);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        className: className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-block-start:16px;", dist.mq.large, "{margin-block-start:24px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                title: "NewsPicksの検索結果",
                helpText: "検索結果について",
                helpLink: "https://help.initial.inc/ja/articles/5676034"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("& >:not(:last-child){border-bottom:1px solid ", dist/* colors.gray50 */.O9.gray50, ";}"),
                children: npFeeds.length !== 0 ? newsPicksFeeds.map(function(feed, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksSearchResult/* NewsPicksFeedSearchResultItem */.SH, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        index: i
                    }, feed), {
                        classPrefix: "investorpage"
                    }), i);
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/pages/investor/InvestorNewsSection.tsx








var InvestorNewsSection = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                children: "ニュース"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorFinanceNewsList/* InvestorFinanceNewsList */.l, {
                list: props.news.finance.data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.news.finance.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/finance-news?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/finance-news"),
                count: props.news.finance.count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksNewsList, {
                investorShortname: props.shortname
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExternalNewsList/* ExternalNewsList */.p, {
                list: props.news.external.data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.news.external.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/external-news?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/external-news"),
                count: props.news.external.count
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/investor/PeopleTable.tsx
var PeopleTable = __webpack_require__(88212);
;// CONCATENATED MODULE: ./components/pages/investor/InvestorPeople.tsx






var InvestorPeople = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                children: "人物"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PeopleTable/* PeopleTable */.K, {
                title: "現職",
                list: props.people.current
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.people.current.length != INVESTOR_TOP_LIST_COUNT,
                href: "/investor/people?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/people")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/investor/InvestorTabGroup.tsx
var InvestorTabGroup = __webpack_require__(23316);
// EXTERNAL MODULE: ./components/pages/investor/LPInvestmentTable.tsx
var LPInvestmentTable = __webpack_require__(66863);
;// CONCATENATED MODULE: ./components/pages/investor/LPInvestments.tsx




var LPInvestments = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                helpText: props.helpText,
                helpProps: props.helpProps,
                children: "LP投資"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LPInvestmentTable/* LPInvestmentTable */.L, {
                list: props.investments,
                shortname: props.shortname
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/pages/investor/CurrentInvestments.tsx
var CurrentInvestments = __webpack_require__(70703);
// EXTERNAL MODULE: ./components/pages/investor/IpoSummaryList.tsx
var IpoSummaryList = __webpack_require__(26404);
// EXTERNAL MODULE: ./components/pages/investor/LeadingVCCompanyList.tsx + 1 modules
var LeadingVCCompanyList = __webpack_require__(58758);
// EXTERNAL MODULE: ./components/pages/investor/PastInvestments.tsx
var PastInvestments = __webpack_require__(80888);
;// CONCATENATED MODULE: ./components/pages/investor/VBInvestments.tsx










var VBInvestments = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                helpText: "直接投資、あるいはGPとして運営しているファンドからの投資",
                helpProps: {
                    size: "large"
                },
                children: "スタートアップ投資"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentInvestments/* CurrentInvestments */.M, {
                list: props.investments.current.data,
                investorShortName: props.shortname
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.investments.current.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/details-current?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/details-current"),
                count: props.investments.current.count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PastInvestments/* PastInvestments */.r, {
                list: props.investments.past.data,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.investments.past.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/details-past?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/details-past"),
                count: props.investments.past.count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeadingVCCompanyList/* LeadingVCCompanyList */.u, {
                list: props.investments.leading.data,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.investments.leading.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/details-leading?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/details-leading"),
                count: props.investments.leading.count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IpoSummaryList/* IpoSummaryList */.M, {
                list: props.investments.ipo.data,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:2rem;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                isHidden: props.investments.ipo.count <= INVESTOR_TOP_LIST_COUNT,
                href: "/investor/details-ipo?shortname=".concat(props.shortname),
                as: "/investors/".concat(props.shortname, "/details-ipo"),
                count: props.investments.ipo.count
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/api/investor.ts
var investor = __webpack_require__(70516);
// EXTERNAL MODULE: ./lib/investor.ts
var lib_investor = __webpack_require__(56027);
// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(61753);
// EXTERNAL MODULE: ./components/common/InviewForActiveTab.tsx
var InviewForActiveTab = __webpack_require__(53565);
// EXTERNAL MODULE: ./lib/page.ts
var lib_page = __webpack_require__(86234);
// EXTERNAL MODULE: ./components/common/MobileGuestFloatingBanner.tsx
var MobileGuestFloatingBanner = __webpack_require__(20438);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/common/ThumbnailFloatingBanner.tsx + 1 modules
var ThumbnailFloatingBanner = __webpack_require__(65013);
// EXTERNAL MODULE: ./lib/api/contentful.ts
var contentful = __webpack_require__(58585);
// EXTERNAL MODULE: ./components/common/MobileGuestSlideBanner.tsx
var MobileGuestSlideBanner = __webpack_require__(54146);
// EXTERNAL MODULE: ./components/common/npStartup/NewsPicksStaticBanner.tsx
var NewsPicksStaticBanner = __webpack_require__(5836);
// EXTERNAL MODULE: ./components/atoms/LoadingOverlay.tsx
var LoadingOverlay = __webpack_require__(82786);
// EXTERNAL MODULE: ./components/atoms/Table.tsx
var Table = __webpack_require__(14792);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(27322);
// EXTERNAL MODULE: ./components/common/table/CompaniesTableBody.tsx + 1 modules
var CompaniesTableBody = __webpack_require__(28695);
// EXTERNAL MODULE: ./components/common/table/CompaniesTableHead.tsx
var CompaniesTableHead = __webpack_require__(91830);
// EXTERNAL MODULE: ./components/atoms/LoadableButton.tsx
var LoadableButton = __webpack_require__(84044);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
;// CONCATENATED MODULE: ./components/pages/investor/molecules/DownloadButton.tsx








var DownloadButton = function(props) {
    var hoverBgColor = "rgba(0, 0, 0, 0.04)";
    var loadingBgColor = "rgba(0, 0, 0, 0.06)";
    var buttonRef = react.useRef(null);
    var buttonLabel = function() {
        return props.isLoading ? "お待ち下さい..." : props.hasPermission ? "Excel形式のファイルをダウンロードできます" : "新プランをご契約のユーザー限定の機能です。新プランへの移行は当社担当者までお問い合わせください。";
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Tooltip */.u, {
            label: buttonLabel(),
            className: props.className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                ref: buttonRef,
                className: "download",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadableButton/* LoadableButton */.L, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    isLoading: props.isLoading,
                    disabled: !props.hasPermission,
                    spinnerColor: dist/* colors.gray70 */.O9.gray70,
                    size: "small",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:center;align-items:center;gap:4px;width:72px;height:40px;padding:4px 2px !important;border:none;color:", dist/* colors.textStrong */.O9.textStrong, ";background-color:", props.isLoading ? loadingBgColor : "transparent", ";font-size:14px !important;font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";&:hover{color:", dist/* colors.textStrong */.O9.textStrong, ";background-color:", hoverBgColor, ";}")
                }, props), {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                            name: "download",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:20px;")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;line-height:100%;align-items:center;text-align:center;letter-spacing:0.02em;"),
                            children: "ダウンロード"
                        })
                    ]
                }))
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/investor/DomesticInvestmentTable.tsx















var DomesticInvestmentTable = function(param) {
    var companies = param.companies, tableRef = param.tableRef, loading = param.loading, page = param.page, count = param.count, handleChangePage = param.handleChangePage, downloading = param.downloading, handleDownload = param.handleDownload;
    var user = (0,AuthContext/* useUser */.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                className: "domestic-invested-table-title",
                title: "スタートアップ",
                children: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && (companies === null || companies === void 0 ? void 0 : companies.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadButton, {
                    hasPermission: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user) && (0,lib_user/* isLatestPlan */.br)(user),
                    isLoading: downloading,
                    onClick: handleDownload,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-left:auto;")
                }) : undefined
            }),
            (companies === null || companies === void 0 ? void 0 : companies.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                ref: tableRef,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                        className: "domestic-invested-table",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompaniesTableHead/* CompaniesTableHead */.Y, {
                                withTotalFunding: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompaniesTableBody/* CompaniesTableBody */.i, {
                                withTotalFunding: (0,lib_user/* isEnterpriseWithTrial */.xQ)(user),
                                items: companies
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay/* LoadingOverlay */.f, {
                        active: loading
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;padding-top:8px;padding-bottom:8px;background-color:", dist/* colors.white10 */.O9.white10, ";"),
                        className: "domestic-company-pagination",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination/* Pagination */.t, {
                            limit: COMPANIES_PER_PAGE,
                            count: count,
                            page: page,
                            setPage: handleChangePage
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./lib/number.ts
var number = __webpack_require__(41181);
// EXTERNAL MODULE: ./components/atoms/LineClampText.tsx
var LineClampText = __webpack_require__(89277);
// EXTERNAL MODULE: ./lib/roundtype.ts
var roundtype = __webpack_require__(39250);
// EXTERNAL MODULE: ./components/common/Help.tsx
var Help = __webpack_require__(33869);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/investor/molecules/OverseasInvestmentTable.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          display: flex;\n                        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                            margin-right: 8px;\n                          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                              margin-top: 8px;\n                            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                font-size: 12px;\n                                line-height: 1.5;\n                              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        vertical-align: middle;\n                      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        padding-left: 23px;\n                        vertical-align: middle;\n                      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        vertical-align: middle;\n                      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                              display: flex;\n                              justify-content: end;\n                            "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                margin-right: 2px;\n                              "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        vertical-align: middle;\n                      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                          display: flex;\n                          justify-content: end;\n                        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                            margin-right: 2px;\n                          "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
















var OverseasInvestmentTable = function(param) {
    var companies = param.companies, page = param.page, count = param.count, handleChangePage = param.handleChangePage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        className: "overseas-invested-card",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardInnerTitle/* CardInnerTitle */.W, {
                className: "overseas-invested-table-title",
                title: "スタートアップ"
            }),
            (companies === null || companies === void 0 ? void 0 : companies.length) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.iA, {
                        className: "overseas-invested-table",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHead */.ss, {
                                className: "header",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("> th{background-color:", dist/* colors.white10 */.O9.white10, ";}"),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "企業名"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            align: "center",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        children: "最新ラウンド"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        children: "調達日"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableHeading */.cq, {
                                            align: "center",
                                            className: "last-funding-type",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            children: "最新ラウンド"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            children: "タイプ"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help/* Help */.W, {
                                                    className: "help",
                                                    linkTo: "https://help.initial.inc/ja/articles/5489432",
                                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("vertical-align:bottom;"),
                                                    children: "定義を見る"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "総調達額"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableHeading */.cq, {
                                            children: "調達後評価額"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                                children: companies.map(function(company, i) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                    var _logoUrl;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* TableRow */.SC, {
                                        highlightOnHover: true,
                                        className: "company-row",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject()),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "company-logo",
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1()),
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                as: "/companies/".concat(company.shortname),
                                                                href: url/* COMPANY_HREF */.bP,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* CompanyLogo */.Dc, {
                                                                        src: (_logoUrl = company.logoUrl) !== null && _logoUrl !== void 0 ? _logoUrl : "/static/images/default/company.png",
                                                                        size: "normal",
                                                                        name: company.name
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    className: "company-name",
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                        as: "/companies/".concat(company.shortname),
                                                                        href: url/* COMPANY_HREF */.bP,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
                                                                            decoration: "none",
                                                                            children: company.name
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    className: "company-description",
                                                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject2()),
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineClampText/* LineClampText */.R, {
                                                                        justify: true,
                                                                        lineNumber: 5,
                                                                        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject3()),
                                                                        stripLineBreaks: true,
                                                                        children: company.description
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                className: "last-funding-date",
                                                width: "104px",
                                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject4()),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                                                    children: (ref = company.lastFundingType) === null || ref === void 0 ? void 0 : ref.date
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                className: "round-type",
                                                width: "128px",
                                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject5()),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    children: ((ref1 = company.lastFundingType) === null || ref1 === void 0 ? void 0 : ref1.type) && (0,roundtype/* formatLastFundingType */.e)((ref2 = company.lastFundingType) === null || ref2 === void 0 ? void 0 : ref2.type)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                className: "total-fundraise",
                                                width: "104px",
                                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject6()),
                                                children: (company === null || company === void 0 ? void 0 : (ref3 = company.totalFundraise) === null || ref3 === void 0 ? void 0 : ref3.currency) && (company === null || company === void 0 ? void 0 : (ref4 = company.totalFundraise) === null || ref4 === void 0 ? void 0 : ref4.value) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject7()),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "currency",
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject8()),
                                                            children: company === null || company === void 0 ? void 0 : (ref5 = company.totalFundraise) === null || ref5 === void 0 ? void 0 : ref5.currency
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "value",
                                                            children: (0,number/* toUnitNumber */.Fk)(company.totalFundraise.value).value.toFixed(1)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "unit",
                                                            children: (0,number/* toUnitNumber */.Fk)(company.totalFundraise.value).unit
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* TableCell */.pj, {
                                                className: "post-money-valuation",
                                                width: "104px",
                                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject9()),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject10()),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "currency",
                                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject11()),
                                                            children: company.valuation && company.valuation.currency
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "value",
                                                            children: ((ref6 = company.valuation) === null || ref6 === void 0 ? void 0 : ref6.value) && (0,number/* toUnitNumber */.Fk)(company.valuation.value).value.toFixed(1)
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            className: "unit",
                                                            children: company.valuation && (0,number/* toUnitNumber */.Fk)(company.valuation.value).unit
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:center;align-items:center;padding-top:8px;padding-bottom:8px;background-color:", dist/* colors.white10 */.O9.white10, ";"),
                        className: "overseas-company-pagination",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination/* Pagination */.t, {
                            limit: COMPANIES_PER_PAGE,
                            count: count,
                            page: page,
                            setPage: handleChangePage
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyCard/* EmptyCard */.S, {})
        ]
    });
};

// EXTERNAL MODULE: ./components/view/EnterpriseGuide.tsx
var EnterpriseGuide = __webpack_require__(30291);
// EXTERNAL MODULE: ./lib/tracking.ts
var tracking = __webpack_require__(56902);
;// CONCATENATED MODULE: ./pages/investors/[shortname]/index.tsx











































var INVESTOR_TOP_LIST_COUNT = 5;
var COMPANIES_PER_PAGE = 5;
var DEFAULT_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
var ref = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* createInViewEventQueue */.ze)(), 2), push = ref[0], apply = ref[1];
var InvestorPage = function(props) {
    var ref, ref1, ref2;
    var user = (0,AuthContext/* useUser */.a)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,InviewForActiveTab/* setupActiveTabs */.ji)(InvestorTabGroup/* allTabList */.x), 2), init = ref3[0], first = ref3[1];
    var ref4 = (0,react.useState)(init()), activeTabs = ref4[0], setActiveTabs = ref4[1];
    var ref5 = (0,react.useState)(), fullInfo = ref5[0], setFullInfo = ref5[1];
    var ref6 = (0,react.useState)(0), count = ref6[0], setCount = ref6[1];
    var ref7 = (0,react.useState)(0), overseasCount = ref7[0], setOverseasCount = ref7[1];
    var ref8 = (0,react.useState)(), companies = ref8[0], setCompanies = ref8[1];
    var ref9 = (0,react.useState)(), overseasCompanies = ref9[0], setOverseasCompanies = ref9[1];
    var ref10 = (0,react.useState)(false), loading = ref10[0], setLoading = ref10[1];
    var ref11 = (0,react.useState)(1), page = ref11[0], setPage = ref11[1];
    var ref12 = (0,react.useState)(1), overseasPage = ref12[0], setOverseasPage = ref12[1];
    var ref13 = (0,react.useState)(false), downloading = ref13[0], setDownloading = ref13[1];
    var tableRef = (0,react.useRef)(null);
    var ref14 = (0,react.useState)(true), isPopupVisible = ref14[0], setIsPopupVisible = ref14[1];
    var ref15 = (0,react.useState)(true), isFloatingBannerVisible = ref15[0], setIsFloatingBannerVisible = ref15[1];
    var isOverseas = function(shortname) {
        return shortname.startsWith("SPD");
    };
    (0,react.useEffect)(function() {
        if (!props.summary || !props.summary.shortname) {
            return;
        }
        setPage(1);
        setOverseasPage(1);
        if (!isOverseas(props.summary.shortname)) {
            (0,investor/* getInvestorFull */.mx)(props.summary.shortname).then(function(res) {
                setFullInfo(res.data);
            });
        } else {
            var dummyFullData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.summary), {
                companies: {
                    count: 0,
                    data: []
                },
                people: {
                    past: [],
                    current: []
                },
                news: {
                    finance: {
                        count: 0,
                        data: []
                    },
                    external: {
                        count: 0,
                        data: []
                    }
                }
            });
            setFullInfo(dummyFullData);
        }
    }, [
        (ref = props.summary) === null || ref === void 0 ? void 0 : ref.shortname
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = props.summary) === null || ref === void 0 ? void 0 : ref.shortname) {
            setLoading(true);
            var offset = COMPANIES_PER_PAGE * (page - 1);
            !isOverseas(props.summary.shortname) && (0,investor/* getInvestorCompanies */.wu)(props.summary.shortname, COMPANIES_PER_PAGE, offset).then(function(res) {
                setCount(res.count);
                setCompanies(res.data);
            }).finally(function() {
                setLoading(false);
            });
        }
    }, [
        (ref1 = props.summary) === null || ref1 === void 0 ? void 0 : ref1.shortname,
        page
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = props.summary) === null || ref === void 0 ? void 0 : ref.shortname) {
            var offset = COMPANIES_PER_PAGE * (overseasPage - 1);
            isOverseas(props.summary.shortname) && (0,investor/* getInvestorOverseasCompanies */.Tj)(props.summary.shortname, COMPANIES_PER_PAGE, offset).then(function(res) {
                setOverseasCompanies(res.data);
                setOverseasCount(res.count);
            });
        }
    }, [
        (ref2 = props.summary) === null || ref2 === void 0 ? void 0 : ref2.shortname,
        overseasPage
    ]);
    var handleChangeActive = function(tab, inView) {
        push(tab, inView, onTimeout);
    };
    var onTimeout = function() {
        setActiveTabs(apply(activeTabs));
    };
    var handleDownload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, ref1, success;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!props.summary) return [
                            3,
                            5
                        ];
                        setDownloading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,investor/* downloadInvestorCompanies */.dc)((ref = props.summary) === null || ref === void 0 ? void 0 : ref.shortname, "xlsx")
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.blob()
                        ];
                    case 3:
                        success = download_default().apply(void 0, [
                            _state.sent(),
                            "".concat(props.summary.name, "_投資先_").concat(timestamp(), ".xlsx"),
                            (ref1 = res.headers.get("content-type")) !== null && ref1 !== void 0 ? ref1 : DEFAULT_MIME
                        ]);
                        (0,tracking/* trackEvent */.L9)(user, "投資家の投資先のダウンロード");
                        if (!success) {
                        // TODO: Show error message
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setDownloading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function(page) {
        setPage(page);
        (0,lib_page/* scrollToRef */.BC)({
            ref: tableRef,
            offset: 150
        });
    };
    var handleChangeOverseasPage = function(page) {
        setOverseasPage(page);
    };
    var checkFooterInView = function() {
        var footer = document.getElementById("footer");
        if (footer === null) return;
        var footerHeight = footer.offsetTop - window.innerHeight;
        if (window.scrollY > footerHeight) {
            setIsPopupVisible(false);
        } else {
            setIsPopupVisible(true);
        }
    };
    var throttledCheckFooterInView = (0,lodash.throttle)(checkFooterInView, 200);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", throttledCheckFooterInView);
        return function() {
            window.removeEventListener("scroll", throttledCheckFooterInView);
        };
    }, []);
    (0,react.useEffect)(function() {
        var hash = location.hash.replace("#", "");
        if (hash) {
            setTimeout(function() {
                var ref;
                (ref = document.getElementById(hash)) === null || ref === void 0 ? void 0 : ref.scrollIntoView(true);
            });
        }
    }, [
        fullInfo,
        companies,
        overseasCompanies,
        user
    ]);
    if (props.statusCode === 403) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseGuide/* EnterpriseGuideTemplate */.P, {});
    } else if (!props.summary || props.statusCode === 404) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorTemplate/* InvestorTemplate */.Z, {
                summary: props.summary,
                tab: first(activeTabs),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                        tabName: "basic-info",
                        onChangeActive: handleChangeActive,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-top:24px;", dist.mq.untilMedium, "{padding-top:16px;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorBasicInfo, {
                                summary: props.summary
                            }),
                            (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:64px 0 34px;", dist.mq.untilMedium, "{display:none;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksStaticBanner/* NewsPicksStaticBanner */.O, {
                                    staticBanner: props.staticBanners ? props.staticBanners[0] : null,
                                    trackingId: "investorpage-static-banner-1"
                                })
                            }),
                            (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:16px;display:none;", dist.mq.untilMedium, "{display:block;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGuestSlideBanner/* MobileGuestSlideBanner */.i, {
                                    slideBannerArticles: props.slideBanners,
                                    trackingIdPrefix: "investorpage"
                                })
                            })
                        ]
                    }),
                    (0,lib_investor/* isVc */.w8)(props.summary) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorInviewForActiveTab, {
                        tabName: "investment-info",
                        onChangeActive: handleChangeActive,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestmentInfo, {
                            summary: props.summary
                        })
                    }),
                    fullInfo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                tabName: "companies",
                                onChangeActive: handleChangeActive,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                        className: "invested-companies",
                                        helpText: "直接投資、あるいはGPとして運営しているファンド（二人組合形式を含む）から投資を行ったスタートアップ。現在は株式を保有していないスタートアップも含む。",
                                        helpProps: {
                                            size: "large"
                                        },
                                        children: "投資先"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;gap:24px;"),
                                        children: [
                                            !isOverseas(props.summary.shortname) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DomesticInvestmentTable, {
                                                companies: companies,
                                                tableRef: tableRef,
                                                loading: loading,
                                                page: page,
                                                count: count,
                                                handleChangePage: handleChangePage,
                                                downloading: downloading,
                                                handleDownload: handleDownload
                                            }),
                                            isOverseas(props.summary.shortname) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverseasInvestmentTable, {
                                                companies: overseasCompanies,
                                                loading: false,
                                                page: overseasPage,
                                                count: overseasCount,
                                                handleChangePage: handleChangeOverseasPage
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0,lib_investor/* isCvc */.tI)(fullInfo) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                        tabName: "acquisitions",
                                        onChangeActive: handleChangeActive,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                children: "買収"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyCardList/* CompanyCardList */.R, {
                                                list: fullInfo.acquisitions.data
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                                                isHidden: fullInfo.acquisitions.count <= INVESTOR_TOP_LIST_COUNT,
                                                href: "/investor/acquisitions?shortname=".concat(props.summary.shortname),
                                                as: "/investors/".concat(props.summary.shortname, "/acquisitions"),
                                                count: fullInfo.acquisitions.count
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                        tabName: "partnerships",
                                        onChangeActive: handleChangeActive,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                                children: "提携先"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyCardList/* CompanyCardList */.R, {
                                                list: fullInfo.partnerships.data
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                                                isHidden: fullInfo.partnerships.count <= INVESTOR_TOP_LIST_COUNT,
                                                href: "/investor/partnerships?shortname=".concat(props.summary.shortname),
                                                as: "/investors/".concat(props.summary.shortname, "/partnerships"),
                                                count: fullInfo.partnerships.count
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0,lib_investor/* isVc */.w8)(fullInfo) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                tabName: "seed-funded",
                                onChangeActive: handleChangeActive,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
                                        children: "シード支援先"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyCardList/* CompanyCardList */.R, {
                                        list: fullInfo.seeds.data
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                                        isHidden: fullInfo.seeds.count <= INVESTOR_TOP_LIST_COUNT,
                                        href: "/investor/seed-funded?shortname=".concat(props.summary.shortname),
                                        as: "/investors/".concat(props.summary.shortname, "/seed-funded"),
                                        count: fullInfo.seeds.count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorInviewForActiveTab, {
                                tabName: "people",
                                onChangeActive: handleChangeActive,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorPeople, {
                                    shortname: props.summary.shortname,
                                    people: fullInfo.people
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ForEnterprise/* ForEnterprise */.L, {
                                children: fullInfo.funds ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                    tabName: "funds",
                                    onChangeActive: handleChangeActive,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorFunds, {
                                            list: fullInfo.funds.data,
                                            investorShortname: props.summary.shortname,
                                            helpText: "GPとして、あるいは二人組合形式で運営しているファンド",
                                            helpProps: {
                                                size: "large"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                                            isHidden: fullInfo.funds.count <= INVESTOR_TOP_LIST_COUNT,
                                            href: "/investor/funds?shortname=".concat(props.summary.shortname),
                                            as: "/investors/".concat(props.summary.shortname, "/funds"),
                                            count: fullInfo.funds.count
                                        })
                                    ]
                                }) : null
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ForEnterprise/* ForEnterprise */.L, {
                                children: fullInfo.investments ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorInviewForActiveTab, {
                                    tabName: "startup-investments",
                                    onChangeActive: handleChangeActive,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VBInvestments, {
                                        shortname: props.summary.shortname,
                                        investments: fullInfo.investments
                                    })
                                }) : null
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ForEnterprise/* ForEnterprise */.L, {
                                children: fullInfo.investments ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InvestorInviewForActiveTab, {
                                    tabName: "lp-investments",
                                    onChangeActive: handleChangeActive,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LPInvestments, {
                                            investments: fullInfo.investments.lp.data,
                                            shortname: props.summary.shortname,
                                            helpText: "LPとして出資したファンド",
                                            helpProps: {
                                                size: "large"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewMoreLink/* ViewMoreLink */.r, {
                                            isHidden: fullInfo.investments.lp.count <= INVESTOR_TOP_LIST_COUNT,
                                            href: "/investor/details-lp?shortname=".concat(props.summary.shortname),
                                            as: "/investors/".concat(props.summary.shortname, "/details-lp"),
                                            count: fullInfo.investments.lp.count
                                        })
                                    ]
                                }) : null
                            }),
                            (0,lib_user/* isGuest */.nJ)(user) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:64px 0 34px;", dist.mq.untilMedium, "{display:none;}"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsPicksStaticBanner/* NewsPicksStaticBanner */.O, {
                                    staticBanner: props.staticBanners ? props.staticBanners[1] : null,
                                    trackingId: "investorpage-static-banner-2"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorInviewForActiveTab, {
                                tabName: "news",
                                onChangeActive: handleChangeActive,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InvestorNewsSection, {
                                    shortname: props.summary.shortname,
                                    news: fullInfo.news
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:center;padding-top:30px;"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* Loader */.a, {})
                    })
                ]
            }),
            (0,lib_user/* isGuest */.nJ)(user) && isPopupVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileGuestFloatingBanner/* MobileGuestFloatingBanner */.V, {
                trackingIdPrefix: "investor-page"
            }),
            (0,lib_user/* isGuest */.nJ)(user) && isFloatingBannerVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbnailFloatingBanner/* ThumbnailFloatingBanner */.G, {
                onClose: function() {
                    return setIsFloatingBannerVisible(false);
                },
                floatingBanner: props.floatingBanners,
                trackingIdPrefix: "investor-page"
            })
        ]
    });
};
var InvestorInviewForActiveTab = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviewForActiveTab/* InViewForActiveTab */.Zv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        offset: "-12em",
        mobileOffset: "-5em",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-block-start:40px;", dist.mq.untilMedium, "{padding-block-start:32px;}")
    }));
};
var timestamp = function() {
    return (0,format["default"])(new Date(), "yyyyMMdd");
};
InvestorPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var shortname, investorSummaryResponse, ref, summary, statusCode, npFeeds, floatingBanners, slideBanners, staticBanners;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    shortname = ctx.query.shortname;
                    return [
                        4,
                        (0,investor/* fetchInvestorSummary */.jM)(ctx, shortname.toString())
                    ];
                case 1:
                    investorSummaryResponse = _state.sent();
                    return [
                        4,
                        Promise.all([
                            investorSummaryResponse === null || investorSummaryResponse === void 0 ? void 0 : investorSummaryResponse.data,
                            investorSummaryResponse === null || investorSummaryResponse === void 0 ? void 0 : investorSummaryResponse.status,
                            (0,feed/* fetchNPFeedsByInvestorShortname */._J)(shortname),
                            (0,contentful/* getNpStartupFloatingBanner */.T4)(),
                            (0,contentful/* getNpStartupSlideBannerArticles */.V6)(),
                            (0,contentful/* getNpStartupStaticBanner */.yy)()
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        6
                    ]), summary = ref[0], statusCode = ref[1], npFeeds = ref[2], floatingBanners = ref[3], slideBanners = ref[4], staticBanners = ref[5];
                    return [
                        2,
                        {
                            summary: summary,
                            statusCode: statusCode,
                            npFeeds: npFeeds,
                            floatingBanners: floatingBanners,
                            slideBanners: slideBanners,
                            staticBanners: staticBanners
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _shortname_ = (InvestorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8687,519,8674,8101,5414,6066,9242,774,3431,3954,2413,9181,655,3660,9774,2888,179], function() { return __webpack_exec__(75507); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);